import {Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {IHeaderDistributorDetail} from '../../../interfaces/detail-header.interface';
import {DistributorStatusEnum} from '@config/enum/distributor.enum';
import {ITabList} from '@shared/interface/tablist.interface';
import {RolePrivilegeService} from '@services/role-privilege.service';
import {TabLabelEnumDetailDistributor, TabListLabelDetailDistributor} from '../../../enum/tablist-label.enum';
import {UtilitiesService} from '@services/utilities.service';
import {DistributorService} from '../../../distributor.service';
import {EditRequestTabPlafonKreditComponent} from './edit-request-plafon/edit-request-tab-plafon-kredit.component';
import {
  EditRequestTabInformasiDistributorComponent
} from './edit-request-informasi-distributor/edit-request-tab-informasi-distributor.component';
import {STRING_CONSTANTS} from '@config/constants/string.constants';
import {STEPPER_GLOBAL_OPTIONS, StepperSelectionEvent} from '@angular/cdk/stepper';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ModalComponent} from '@shared/components/modal/modal.component';
import {ModalConfig} from '@shared/components/modal/modal.interface';
import {IGenericLabelValue} from '@shared/interface/generic';
import {DetailRegistrationDistributorService} from '../detail-registration/detail-registration.service';
import {
  IPayloadRegistrationDeliveryAddress,
  IPayloadRegistrationVerification
} from '../../../interfaces/detail-registration.interface';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {
  IPayloadVerificationPlafonKredit,
  IResponseConfirmVerifyDistributor,
  IResponseVerificationDistributor
} from '../../../interfaces/detail-verification.interface';
import {EnumDistributorRevisionSession} from '@config/enum/session.enum';
import {BusinessDataComponent} from '../detail-registration/business-data/business-data.component';

@Component({
  selector: 'app-detail-edit-request',
  templateUrl: './detail-edit-request.component.html',
  styleUrls: ['./detail-edit-request.component.scss'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: {displayDefaultIndicatorType: false},
    },
  ],
})
export class DetailEditRequestComponent implements OnInit {
  @Input() detailHeaderSubject!: BehaviorSubject<IHeaderDistributorDetail>;

  tabIndex = 0;
  tabList!: ITabList[];
  activeStepIndex = 0;
  revisionType: EnumDistributorRevisionSession;
  revisionNote: BehaviorSubject<IGenericLabelValue[]> = new BehaviorSubject<IGenericLabelValue[]>([]);
  snapshotParams: Params;

  responseVerification = new BehaviorSubject<IResponseVerificationDistributor | undefined>(undefined);
  confirmVerify: IResponseConfirmVerifyDistributor = {} as IResponseConfirmVerifyDistributor;
  responseConfirmChangeSubArea: string[] = [];

  distributorDataForm: FormGroup = this.fb.group({
    scope: ['', Validators.required],
    distributor_detail: ['', Validators.required],
    owner: [''],
    manager: [''],
    business_branch: [''],
  });

  businessDataForm: FormGroup = this.fb.group({
    business_information: ['', Validators.required],
    supplier_information: ['', Validators.required],
  });
  businessInformationHasRevision = new BehaviorSubject(false);

  shippingAddressForm: FormGroup = this.fb.group({
    delivery_address: [[], Validators.required],
  });

  documentForm: FormGroup = this.fb.group({
    document: ['', Validators.required],
    document_update_distributor: ['', Validators.required],
  });

  @ViewChild('modalConfirmVerification') modalConfirmVerification: ModalComponent;
  modalConfigConfirmVerification: ModalConfig = {
    modalTitle: 'KONFIRMASI PEMBARUAN DATA DISTRIBUTOR',
    dismissButtonLabel: 'Lanjutkan',
    closeButtonLabel: 'Batal',
    onDismiss: () => this.onSubmitVerification(),
  };

  @ViewChild('modalSuccessResetPassword') private modalSuccessResetPassword: ModalComponent;
  modalSuccessResetPasswordConfig: ModalConfig = {
    onDismiss: () => this.goToList(),
    onClose: () => this.goToDetail(),
    dismissButtonLabel: 'Oke',
    closeButtonLabel: 'Lihat Detail',
  };

  @ViewChild('modalResponse') private modalResponse: ModalComponent;
  modalResponseConfig: ModalConfig = {
    onDismiss: () => this.goToList(),
    onClose: () => this.goToDetail(),
    dismissButtonLabel: 'Oke',
    closeButtonLabel: 'Lihat Detail',
  };

  // init declare object session
  revisionNoteData = {
    editRequestFinance: <IPayloadVerificationPlafonKredit>{
      revision_note: {
        credit_ceiling_granted: null,
        credit_billing: null,
        sale_target: null,
        document_update_distributor: null,
      },
    },
  };

  @ViewChild('businessDataRef') businessDataRef!: BusinessDataComponent;
  @ViewChild('defaultVerifyConfirmText') defaultVerifyConfirmText!: TemplateRef<any>;
  @ViewChild('toFinanceConfirmText') toFinanceConfirmText!: TemplateRef<any>;

  get isPendingVerification() {
    return this.detailHeaderSubject.value.status_enum === DistributorStatusEnum.PENDING_EDIT_VERIFICATION;
  }

  get sessionRevisionNote() {
    return this.registrationService.getSessionRevisionNote(this.revisionType) ?? ({} as IPayloadRegistrationDeliveryAddress);
  }

  get IsChangeEmail() {
    return !this.distributorDataForm.get('distributor_detail')?.value && this.confirmVerify.change_email;
  }

  constructor(
    public utilities: UtilitiesService,
    private rolePrivilegeService: RolePrivilegeService,
    public distributorService: DistributorService,
    private router: Router,
    private registrationService: DetailRegistrationDistributorService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute
  ) {
    this.snapshotParams = this.activatedRoute.snapshot.params;
  }

  ngOnInit(): void {
    this.detailHeaderSubject.subscribe((resp) => {
      if (resp && !Object.keys(resp).length) return;

      const {status_enum} = resp;
      this.revisionType =
        status_enum === DistributorStatusEnum.PENDING_EDIT_VERIFICATION ? EnumDistributorRevisionSession.EDIT_REQUEST_ADMIN : EnumDistributorRevisionSession.EDIT_REQUEST_FINANCE;
      this.initTabList();
      this.initSessionRevisionNote();
    });
    this.checkChangeEmail();
    this.getDeletedPE();
  }

  checkChangeEmail() {
    this.registrationService.getConfirmVerify().subscribe((value) => {
      if (!value) return;
      this.confirmVerify = value;
    });
  }

  getDeletedPE() {
    this.registrationService.getDeletedPE().subscribe((value) => {
      this.responseConfirmChangeSubArea = value ?? [];
    });
  }

  initTabList() {
    const {status_enum} = this.detailHeaderSubject.value;
    this.tabList = this.distributorService.generateDistributorDetailTabList(status_enum);
    this.tabList.map((tab, index) => {
      tab.privilege = this.rolePrivilegeService.checkPrivilege('DISTRIBUTOR', 'DETAIL_DISTRIBUTOR', tab.enum);
      tab.index = index;
      if (tab.enum === TabLabelEnumDetailDistributor.TAB_PLAFON_CREDIT) tab.component = EditRequestTabPlafonKreditComponent;
      if (tab.enum === TabLabelEnumDetailDistributor.TAB_DISTRIBUTOR_INFORMATION) tab.component = EditRequestTabInformasiDistributorComponent;
    });
  }

  onStepChange(event: StepperSelectionEvent): void {
    this.activeStepIndex = event.selectedIndex;
    setTimeout(() => {
      if (this.businessDataRef) this.handleBusinessDataRef();
    });
  }

  handleConfirm() {
    this.generateNoteRevision();
    this.modalConfirmVerification.open().then();
  }

  generateNoteRevision() {
    const revisionNoteData = this.sessionRevisionNote;
    const data = this.distributorService.generateNoteRevision(revisionNoteData) ?? [];
    this.revisionNote.next(data);
  }

  handleTabChange = (e: number) => (this.tabIndex = e);

  onSubmitVerification() {
    const revision = this.sessionRevisionNote;
    const delivery_address = revision?.delivery_address?.flatMap((value: { id: any; note: any }) => ({
      id: value.id,
      note: value.note,
    }));
    const revision_note = revision?.revision_note;
    if (revision_note || delivery_address) {
      const payload = {} as IPayloadRegistrationVerification;
      payload.revision_note = revision_note;
      revision_note.delivery_address = delivery_address;
      this.registrationService.submitVerificationAdmin(payload).subscribe((val) => {
        if (val && val.success) {
          this.responseVerification.next(val.data);
          this.registrationService.clearSessionRevisionNote(this.revisionType);
          if (this.IsChangeEmail) {
            return this.modalSuccessResetPassword.open().then();
          } else {
            return this.modalResponse.open().then();
          }
        }
      });
    }
    return true;
  }

  goToList = () => {
    this.router.navigate(['/distributor/pending/registration']).then();
    return true;
  };

  goToDetail = () => {
    const id = this.responseVerification.value?.distributor_id;

    this.router.navigateByUrl('/RefreshComponent', {skipLocationChange: true}).then(() => {
      this.router.navigate(['/distributor/teregistrasi/active/' + id]).then();
    });
    return true;
  };

  initSessionRevisionNote() {
    if (!this.hasRevisionSession()) {
      if (this.revisionType === EnumDistributorRevisionSession.EDIT_REQUEST_ADMIN) {
        const data: IPayloadRegistrationDeliveryAddress = {
          revision_note: {
            scope: null,
            distributor_detail: null,
            owner: null,
            manager: null,
            business_branch: null,
            business_information: null,
            supplier_information: null,
            sale_target: null,
            document: null,
            npwp_information: null,
            npwp_document: null,
            document_update_distributor: null,
          },
          delivery_address: null,
        };
        const sessionData = this.sessionRevisionNote;
        if (sessionData && Object.keys(sessionData).length) {
          data.delivery_address = sessionData.delivery_address;
          data.revision_note = sessionData.revision_note;
        }
        this.registrationService.setSessionRevisionNote(data, this.revisionType);
      } else {
        this.registrationService.setSessionRevisionNote(this.revisionNoteData.editRequestFinance, this.revisionType);
      }
    }
  }

  hasRevisionSession = () => !!(this.sessionRevisionNote && Object.keys(this.sessionRevisionNote).length);

  showButtonGroup = () => this.registrationService.checkBtnVerification(this.snapshotParams.tab);

  generateDescSuccess() {
    if (this.revisionNote.value && !!this.revisionNote.value.length) {
      return 'Permintaan pembaruan data distributor berhasil dikonfirmasi.\n' + 'Catatan perbaikan & Data Distributor dikembalikan ke Regional Head.';
    }
    if (this.confirmVerify.change_credit_ceiling) return 'Permintaan pembaruan data distributor berhasil dikonfirmasi & diteruskan ke Finance.';
    return 'Permintaan pembaruan data distributor berhasil dikonfirmasi.';
  }

  handleBusinessDataRef() {
    if (!this.businessDataRef) return;
    const _businessDataSubject = this.businessDataRef.dataValue;
    _businessDataSubject.subscribe((data) => {
      if (data && !Object.keys(data).length) return;
      this.businessInformationHasRevision.next(!!(data && data.business_information.revision_data));
    });
  }

  // note: if business information has revision - confirm should go to finance

  showDescConfirmation() {
    const checkRevision = this.revisionNote.value.length <= 0;
    return !this.confirmVerify.change_credit_ceiling && checkRevision;
  }

  protected readonly TabListLabelDetailDistributor = TabListLabelDetailDistributor;
  protected readonly DistributorStatusEnum = DistributorStatusEnum;
  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
}
